import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';

import { __ } from '../../../../utils.jsx';
import moment from 'moment';

var Item = createReactClass({
  propTypes: {
    name: PropTypes.string,
    id: PropTypes.string,
    type: PropTypes.string,
    uri: PropTypes.string,
    size: PropTypes.number,
    isDirectory: PropTypes.bool,
    previewURL: PropTypes.string,
    deleteItem: PropTypes.func,
    onItemClick: PropTypes.func,
    selected: PropTypes.bool,
    bulkDeleteMode: PropTypes.bool,
    onBulkSelectItem: PropTypes.func,
    selectedForBulkDelete: PropTypes.bool,
  },

  hoverTimer: -1,

  getDefaultProps: function () {
    return {
      name: '',
      type: '',
      uri: '',
      size: 0,
      previewURL: PropTypes.string,
      deleteItem: function () {},
      onItemClick: function () {},
      selected: false,
      bulkDeleteMode: false,
      onBulkSelectItem: function () {},
      selectedForBulkDelete: false,
    };
  },

  getInitialState: function () {
    return {
      isImage: this.isImage(this.props.type),
      sizeString: this.getSizeString(this.props.size),
      extension: this.getFileExtension(this.props.name),
      hovering: false,
      selected: this.props.selected,
      selectedForBulkDelete: this.props.selectedForBulkDelete,
      copied: false,
    };
  },

  componentWillUnmount: function () {
    clearTimeout(this.copiedTimer);
  },

  isImage: function (type) {
    if (type === 'image/jpeg' || type === 'image/png' || type === 'image/gif') {
      return true;
    }
    return false;
  },

  getSizeString: function (size) {
    if (size > 1000000) {
      return Math.round(size / 1000000) + ' MB';
    } else if (size > 1000) {
      return Math.round(size / 1000) + ' kB';
    } else {
      return size + ' B';
    }
  },

  getFileExtension: function (filename) {
    return filename.substr(filename.lastIndexOf('.') + 1).toUpperCase();
  },

  onItemClick: function (evt) {
    if (!this.props.isDirectory && this.props.multipleSelect) {
      this.setState({
        selected: !this.state.selected,
      });
    }

    this.props.onItemClick({
      name: this.props.name,
      isDirectory: this.props.isDirectory,
      type: this.props.type,
      uri: this.props.uri,
      id: this.props.id,
      dir: this.props.dir,
    });
  },

  onDeleteClick: function (evt) {
    evt.stopPropagation();
    evt.preventDefault();
    var msg = '';

    let p = this.props.uri;
    if (this.props.isDirectory) {
      msg = __('Naozaj chcete zmazať priečinok ' + this.props.name + '?');
      p = this.props.id;
    } else {
      msg = __('Naozaj chcete zmazať súbor ' + this.props.name + '?');
    }

    var r = window.confirm(msg);

    if (r === true) {
      this.props.onDeleteItem({
        name: this.props.name,
        path: p,
        isDirectory: this.props.isDirectory,
      });
    }
  },

  onCheckboxChange: function (evt) {
    evt.stopPropagation();
    const isChecked = evt.target.checked;
    this.setState({ selectedForBulkDelete: isChecked });
    this.props.onBulkSelectItem({
      id: this.props.id,
      isDirectory: this.props.isDirectory,
      name: this.props.name,
      uri: this.props.uri,
    }, isChecked);
  },

  onCopyLinkClick: function (evt) {
    evt.stopPropagation();
    evt.preventDefault();

    const url = 'https://data.tvkosice.sk/cmdata/' + this.props.uri;
    // ak clipboard API nie je dostupne (napr. http), zobrazime odkaz na rucne skopirovanie
    const fallback = () => {
      window.prompt(__('Odkaz na súbor:'), url);
    };

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(url)
        .then(() => {
          this.setState({ copied: true });
          clearTimeout(this.copiedTimer);
          this.copiedTimer = setTimeout(() => {
            this.setState({ copied: false });
          }, 2000);
        })
        .catch(fallback);
    } else {
      fallback();
    }
  },

  onDropFile: function (evt) {
    evt.stopPropagation();

    let p = this.props.id;
    if (this.props.isDirectory) {
      let transferData = JSON.parse(evt.dataTransfer.getData('data'));
      let data = {
        file: !transferData.isDir,
        destinationId: p,
        originId: transferData.id,
      };

      if (!transferData.isDir || !data.destinationId === data.originId) {
        this.props.onItemMove(data);
      }

      this.setState({
        hovering: false,
      });
    }
  },

  onDragStart: function (e) {
    let p = this.props.uri;
    let isDirectory = false;
    if (this.props.isDirectory) {
      p = this.props.id;
      isDirectory = true;
    }

    let transferData = JSON.stringify({ id: p, isDir: isDirectory });

    e.dataTransfer.setData('data', transferData);
  },

  onDragEnter: function (e) {
    e.preventDefault();
    if (this.props.isDirectory) {
      this.hoverTimer = Date.now();
      this.setState({
        hovering: true,
      });
      // this.props.onDragLeave(e);
    }
  },
  onDragOver: function (e) {
    e.preventDefault();
    if (this.props.isDirectory) {
      // ak nahodou ondragenter nezachytil event
      if (!this.state.hovering) {
        this.setState({
          hovering: true,
        });
      }

      if (this.hoverTimer === Number.MAX_VALUE) {
        this.hoverTimer = Date.now();
      }

      if (Date.now() - this.hoverTimer > 1000) {
        this.props.onItemClick({
          name: this.props.name,
          isDirectory: this.props.isDirectory,
          type: this.props.type,
          uri: this.props.uri,
          id: this.props.id,
          dir: this.props.dir,
        });
        this.hoverTimer = Number.MAX_VALUE;
      }
    }
  },
  onDragLeave: function (e) {
    e.preventDefault();
    this.hoverTimer = Number.MAX_VALUE;
    this.setState({
      hovering: false,
    });
    // this.props.onDragEnter(e);
  },

  render: function () {
    var container1 = null;
    var container2 = null;
    if (this.props.isDirectory === true) {
      container1 = <div className="picture-area directory-area dir-icon" />;
      container2 = (
        <div>
          <span className="directory-title">{this.props.name}</span>
        </div>
      );
    } else {
      var container1ClassName =
        'picture-area directory-area file-icon file-icon-' +
        this.state.extension.toLowerCase();
      // podla pripony priradime classu

      var previewImg = null;
      if (this.props.uri !== '' && this.state.isImage === true) {
        previewImg = (
          <img
            src={
              'https://data.tvkosice.sk/images/cm/0x110xresize/' +
              this.props.uri
            }
            loading="lazy"
            width="158"
            height="110"
          />
        );
      }
      const a = moment(this.props.created);
      container1 = <div className={container1ClassName}>{previewImg}</div>;
      container2 = (
        <div className="picture-desc">
          <span className="directory-title">{this.props.name}</span>
          <table className="file-desc">
            <tbody>
              <tr>
                <td>
                  <span className="file-type">{this.state.extension}</span>
                </td>
                <td className="text-right">
                  <span>{this.state.sizeString}</span>
                </td>
              </tr>
              <tr>
                <td className="text-right">
                  <span>{a.format('DD.MM.YYYY')}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      );
    }

    var deleteStyle = {};
    if (this.props.type === 'parent') {
      deleteStyle = { display: 'none' };
    }

    if (this.props.bulkDeleteMode) {
      deleteStyle = { display: 'none' };
    }

    var style = { border: '2px solid #ccd2dc' };
    if (this.state.hovering) {
      style = { border: '2px solid rgb(66,133,244)' };
    }

    if (this.state.selected) {
      style = { border: '2px solid rgb(92, 184, 92)' };
    }

    if (this.props.bulkDeleteMode && this.state.selectedForBulkDelete) {
      style = { border: '2px solid rgb(217, 83, 79)' };
    }

    var checkbox = null;
    if (this.props.bulkDeleteMode && this.props.type !== 'parent') {
      checkbox = (
        <div className="bulk-delete-checkbox">
          <input
            type="checkbox"
            checked={this.state.selectedForBulkDelete}
            onChange={this.onCheckboxChange}
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      );
    }

    return (
      <div
        draggable={this.props.draggable}
        onDragStart={this.onDragStart}
        onDrop={this.onDropFile}
        onClick={this.onItemClick}
        onDragEnter={this.onDragEnter}
        onDragOver={this.onDragOver}
        onDragLeave={this.onDragLeave}
        style={style}
        className="picture-holder"
      >
        {checkbox}
        <span
          style={deleteStyle}
          onClick={this.onDeleteClick}
          className="delete-icon"
        />
        {!this.props.isDirectory && this.props.type !== 'parent' && (
          <span
            onClick={this.onCopyLinkClick}
            className="copy-link-icon"
            title={this.state.copied ? __('Skopírované') : __('Kopírovať odkaz')}
          >
            <i className={this.state.copied ? 'fa fa-check' : 'fa fa-link'} />
          </span>
        )}
        {container1}
        {container2}
      </div>
    );
  },
});

export default Item;



// WEBPACK FOOTER //
// ./src/js/app/cm/components/mediaBrowser/Item.jsx